import PropTypes from 'prop-types';
import InfoPanel from "../InfoPanel/InfoPanel";
import { NOTE_DISCLOSURE_MESSAGE } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
const NoteDisclosure = _ref => {
  let {
    className = ""
  } = _ref;
  return /*#__PURE__*/_jsx(InfoPanel, {
    className: className,
    message: NOTE_DISCLOSURE_MESSAGE
  });
};
NoteDisclosure.propTypes = {
  className: PropTypes.string
};
export default NoteDisclosure;
//# sourceMappingURL=index.js.map